export default __webpack_public_path__ + "static/media/newsElon.2155a833.png";